<template>
  <section class="mb-12 text-center">
    <h1 class="font-weight-light mb-2 headline" v-text="`${heading}`" />
    <slot name="body" :item="item" />
  </section>
</template>

<script>
  export default {
    name: 'VComponent',

    props: {
      heading: {
        type: String,
        default: '',
      },
      item: {
        type: Object,
        default: null,
      },
    },
  }
</script>
